/**
 * Arche Builder file-map helpers shared by the API client.
 */

/**
 * Drops `node_modules/` entries from a builder file map before upload. The
 * session keeps the SDK's source there as reference material for the AI
 * (~640 KB in SDK 2.27). The server owns that copy: the preview build never
 * reads it (it resolves the SDK itself) and a file save keeps the session's
 * own copy. Sending it pushed real projects past the request body limit
 * ("Request body is too large").
 *
 * Matches the server's rule exactly — only a top-level `node_modules/` key.
 */
export function withoutPackageFiles<T>(files: Record<string, T>): Record<string, T> {
  return Object.fromEntries(
    Object.entries(files).filter(([filePath]) => !filePath.startsWith('node_modules/')),
  );
}
